import { useTranslation } from "react-i18next";

export default function UniversityAction({ iconOnly = false, variant = "primary", className = "" }) {
  const { t } = useTranslation();
  const label = t("action.enterUniversity");
  const classes = ["tgwe-cta", `tgwe-cta--${variant}`, iconOnly ? "tgwe-university-icon" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <a className={classes} href="/university/" title={iconOnly ? label : undefined} aria-label={iconOnly ? label : undefined}>
      {iconOnly ? (
        <span aria-hidden="true">🎓</span>
      ) : (
        <>
          <span>{label}</span>
          <span aria-hidden="true">🎓</span>
        </>
      )}
    </a>
  );
}
